import {
  adminUri,
  appVersion,
  coreApiRootUrl,
  getEnvValue,
  logrocketApp,
  marketingUri,
  olarkId,
} from '@fv/client-core'
import { MAX_ITEM_COUNT } from '@fv/models'

export { adminUri, appVersion, logrocketApp, marketingUri, olarkId }
export const defaultPageSize = 20
export const apiUri = `${coreApiRootUrl}/shipper`

export const countryCodes = {
  CA: 'ca',
  CAN: 'ca',
  MEX: 'mx',
  MX: 'mx',
  US: 'us',
}

export const refrigeratedEquipmentTypes = [
  'refrigerated-48',
  'refrigerated-53',
  'partial-refrigerated',
]
export const supportMessage = 'please contact support if the issue persists.'
export const supportMessageQuestions =
  'Please contact support if you have any questions.'
export const maxItemCount = MAX_ITEM_COUNT
export const MAX_ALT_EQUIP = 5

// Feature flags
export const hasLegacyDetail = JSON.parse(
  getEnvValue('VITE_HAS_LEGACY_DETAIL') ?? 'false',
)

export type SettingsPageType =
  | 'integration'
  | 'user-preferences'
  | 'account-settings'
  | 'shipment-templates'
  | 'product-catalog'
  | 'tag-management'
  | 'gl-code-management'
  | 'quote-filters'
  | 'change-password'
  | 'branding'
  | 'bill-to'
  | 'address-book'
  | 'spot-quote'
  | 'subscription'
  | 'vendors'
  | 'document-center'
